import React from 'react'

export default [
  {
    promoted: true,
    slug: 'arbeiderpartiet',
    name: 'Arbeiderpartiet',
    preamble: 'Skreddersydd plattform',
    cta: 'Hva vi har gjort for Arbeiderpartiet ->',
    description: (
      <p>
        For Arbeiderpartiet har vi levert et system for håndtering av medlemmer, nettsider og
        intranett. Dette er en skreddersydd plattform og publiseringsverktøy for høy
        trafikk.
      </p>
    ),
  },
  {
    promoted: true,
    slug: 'vipps',
    name: 'Vipps',
    preamble: 'Nye moderne nettsider',
    cta: 'Se hva vi har levert til Vipps ->',
    description: (
      <p>
        Sammen med Netlife har vi laget de nye nettsidene til Vipps.
      </p>
    ),
  },
  {
    promoted: true,
    slug: 'ncl',
    name: 'NCL',
    preamble: 'Booking og sporing av containere',
    cta: 'Hva vi har gjort for NCL ->',
    description: (
      <p>
        Nye nettsider for booking og sporing for transport av containere.
      </p>
    ),
  },
  {
    promoted: true,
    slug: 'clooger',
    name: 'Clooger',
    preamble: 'Avansert geolokasjon',
    cta: 'Mer om hva vi har gjort for Clooger ->',
    description: (
      <p>
        Servere og databaser for stor trafikk og avanserte beregninger
        for kart og geolokasjon, med API-er for mobilapper.
      </p>
    ),
  },
/*
  {
    promoted: true,
    slug: 'mcuber',
    name: 'Mcuber',
    preamble: 'Ambisiøst og innovativt læringsspill',
    cta: 'Hva vi har gjort for Mcuber ->',
    description: (
      <p>
        Backend server applikasjon for adaptiv læring med API mot 3D spill utviklet i Unreal Engine.
        Applikasjonen analyserer gjennomføring av oppgaver, og gir nye oppgaver tilpasset spillernes
        ferdighetsnivå.
      </p>
    ),
  },
*/
  {
    name: 'Universitetet i Oslo',
    preamble: 'Rendyrket og effektivt retteverktøy.',
  },
  {
    name: 'BDO CERT',
    preamble: 'Sikring mot digitale trusler.',
  },
  {
    name: 'FlipClass',
    preamble: 'Matematikk og fysikk på mobilen.',
  },
  {
    name: 'Østmøllene',
    preamble: 'Nettsted med smart bestilling av fôr.',
  },
]



// WEBPACK FOOTER //
// ./src/data/cases.js